<template>
  <div class="post-entertainment">
    <div
      :class="[
        'section-title d-flex justify-content-between align-items-center',
        darkClass && 'title' in darkClass ? darkClass.title : '',
      ]"
    >
      <h3 class="title">展会与项目</h3>
      <router-link :to="`/articles?channel=6`">查看更多</router-link>
    </div>
    <div class="row">
      <template v-for="(data, index) in news">
        <div :key="index" class="col-lg-6 col-md-6">
          <divide-card
            :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
            stype="col"
            :datas="data"
            v-if="data"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DivideCard from "../Utility/Cards/DivideCard.vue";
export default {
  components: { DivideCard },
  props: {
    darkClass: {
      type: Object,
    },
  },
  inject: ['dataWrapper', 'fetchStatus'],
  data: () => ({
    news: [],
  }),
  watch: {
    'fetchStatus.isFetched': {
      handler(newVal) {
        if (newVal) {
          this.news = Array.isArray(this.dataWrapper.articles) 
            ? this.dataWrapper.articles.filter(item => item.orgchannel === '6').slice(0, 4) 
            : [];
        }
      },
      immediate: true,
      deep: true
    }
  },
};
</script>

<style>
</style>